export default __webpack_public_path__ + "static/media/aboutus.9b2e6e68.jpg";